/**
 * Virtual Tour Modal functionality
 */
export class VirtualTourModal {
    constructor() {
        this.modal = document.getElementById('virtual-tour-modal');
        this.tourbtns = document.querySelectorAll('[tour-virtual]');
        this.closeBtn = document.querySelector('.modal-close');
        this.overlay = document.querySelector('.modal-overlay');
        this.iframe = document.getElementById('tour-iframe');

        // Get tour URL from the product data
        // Try to get from a script tag with tour data (set by PHP)
        const tourDataScript = document.getElementById('tour-url-data');
        if (tourDataScript) {
            try {
                const tourData = JSON.parse(tourDataScript.textContent);
                this.tourUrl = tourData.url || '';
                console.log('[VirtualTourModal] Tour URL loaded:', this.tourUrl);
            } catch (e) {
                console.error('[VirtualTourModal] Error parsing tour URL data:', e);
                this.tourUrl = '';
            }
        } else {
            console.warn('[VirtualTourModal] Tour URL data script not found');
            this.tourUrl = '';
        }

        this.init();
    }

    init() {
        const self = this;
        if (!self.modal || !self.tourbtns) return;

        // Open modal on button click
        self.tourbtns.forEach(btn => {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                let tourLink = btn.getAttribute('href') || '';
                if (tourLink) {
                    self.tourUrl = tourLink;
                }
                self.openModal();
            });
        });

        // Close modal on close button click
        if (self.closeBtn) {
            self.closeBtn.addEventListener('click', () => {
                self.closeModal();
            });
        }

        // Close modal on overlay click
        if (self.overlay) {
            self.overlay.addEventListener('click', () => {
                self.closeModal();
            });
        }

        // Close modal on ESC key press
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && self.modal.classList.contains('active')) {
                self.closeModal();
            }
        });
    }

    openModal() {
        // Check if we have a valid URL
        if (!this.tourUrl || this.tourUrl === 'https://link' || this.tourUrl === 'http://link') {
            console.warn('[VirtualTourModal] No valid tour URL available. URL:', this.tourUrl);
            alert('Tour virtual não disponível para este produto.');
            return;
        }

        // Set iframe src
        if (this.iframe) {
            this.iframe.src = this.tourUrl;
            console.log('[VirtualTourModal] Opening modal with URL:', this.tourUrl);
        }

        // Show modal
        if (this.modal) {
            this.modal.style.display = 'block';

            // Trigger reflow to ensure transition works
            this.modal.offsetHeight;

            // Add active class for fade-in effect
            setTimeout(() => {
                this.modal.classList.add('active');
            }, 10);

            // Prevent body scroll
            document.body.style.overflow = 'hidden';
        }
    }

    closeModal() {
        // Remove active class for fade-out effect
        this.modal.classList.remove('active');

        // Hide modal and clear iframe after transition
        setTimeout(() => {
            this.modal.style.display = 'none';
            if (this.iframe) {
                this.iframe.src = '';
            }
        }, 300);

        // Restore body scroll
        document.body.style.overflow = '';
    }
}